import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { TopRightOverlay } from 'components/TopRightOverlay/index.js'
import { shouldShowUpgradeDiscountUserSelect } from 'modules/training/modules/training-users/selectors/should-show-upgrade-discount/index.js'

const messages = defineMessages({
  exclusiveUpgradeOffer: {
    id: 'ExclusiveUpgradeOffer.exclusiveUpgradeOffer',
    defaultMessage: '🎉 Exclusive upgrade offer'
  }
})

export function ExclusiveUpgradeOffer () {
  const intl = useIntl()
  const shouldShowUpgradeDiscountUser = useSelector(shouldShowUpgradeDiscountUserSelect)

  if (!shouldShowUpgradeDiscountUser) {
    return
  }

  return (
    <TopRightOverlay>
      <span>{formatMessageIntlUtil(intl, messages.exclusiveUpgradeOffer)}</span>
    </TopRightOverlay>
  )
}
